import api from '../../api/nodeBackApi';

// URL base desde el .env (con fallback por seguridad)
const WEBBACK_URL = process.env.REACT_APP_WEBBACKURL || 'https://webback.lisual.com';

/**
 * Helper para obtener la configuración con el token de autenticación
 */
const getAuthConfig = (extraConfig = {}) => {
  const token = localStorage.getItem("authLisualToken");
  return {
    ...extraConfig,
    headers: {
      ...extraConfig.headers,
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
};

/**
 * Obtiene la lista de templates de Instagram Stories
 */
export const getInstagramTemplates = async () => {
  const response = await api.get(`${WEBBACK_URL}/api/instagram-story/templates`, getAuthConfig());
  return response.data;
};

/**
 * Envía la petición para generar la imagen y la descarga
 */
export const generateInstagramStory = async (payload) => {
  const response = await api.post(`${WEBBACK_URL}/api/instagram-story`, payload, getAuthConfig({
    responseType: 'blob'
  }));
  return response.data;
};